import React, { lazy } from 'react'
import { Switch, Route, useRouteMatch } from 'react-router-dom'

const Tickets = lazy(() => import('../../container/tickets'))

const TicketsRoutes = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path} component={Tickets} />
      <Route path={`${path}/:orderId`} component={Tickets} />
    </Switch>
  )
}

export default TicketsRoutes
